import { ChangeDetectionStrategy, Component, OnInit, OnDestroy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ApiService } from "app/services/api.service";
import { ICompanyGroup } from "../new-residents/new-residents-interfaces";
import { MomentPipe } from "app/pipes/pipes";
import { LocalStorageService } from "app/services/local-storage.service";
import { Subscription } from "rxjs";
import { DeviceStatusComponent } from "app/components/dashboard/devicestatus/devicestatus.component";
import { ActiveAlertsComponent } from "app/components/dashboard/active-alerts/active-alerts.component";
import { CommonModule } from "@angular/common";

@Component({
  selector: "landing-page-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [CommonModule, TranslateModule, MomentPipe, DeviceStatusComponent, ActiveAlertsComponent]
})
export class LandingPageDashboardComponent implements OnInit, OnDestroy {
  constructor(private api: ApiService, private localStorageService: LocalStorageService) {}

  locations: ICompanyGroup[] = [];
  locationsLoaded = false;

  onlineStatus: any;
  notifications: any[] = [];

  user: any;

  /** Landing page user (95): the full Dashboard for every site in the company group */
  isLandingPageUser = false;
  /** Show the sections other than News: landing page users, or anyone with a site with Portal access */
  showDashboard = false;

  private langSubscription: Subscription;

  refreshOnlineStatus(): void {
    this.api.getOnlineStatusCompanyGroup().subscribe((res: any) => {
      this.onlineStatus = res;
    });
  }

  private loadNotifications(): void {
    const lang = localStorage.getItem('language') || 'en';
    const landingPageUser = JSON.parse(localStorage.getItem('landing-page') || '{}')?.user;
    const serverName = (landingPageUser?.serverName || '').trim();

    this.api.getNotifications(lang, 50, false, serverName).subscribe((res: any[]) => {
      const list = Array.isArray(res) ? res : [];
      this.notifications = list
        .filter(n => n.batchId)
        .sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
    });
  }

  ngOnInit(): void {
    const landingPageData = JSON.parse(localStorage.getItem('landing-page') || '{}');
    this.user = landingPageData?.user;
    const customers = Array.isArray(landingPageData?.customers) ? landingPageData.customers : [];

    this.isLandingPageUser = this.user?.roleLevel === 95;
    this.showDashboard = this.isLandingPageUser || customers.length > 0;

    // News for everyone
    this.loadNotifications();
    this.langSubscription = this.localStorageService.currentLanguage.subscribe(() => {
      this.loadNotifications();
    });

    // No Portal access: load nothing else
    if (!this.showDashboard) {
      return;
    }

    this.api.getCompanyGroups().subscribe(
      (res: ICompanyGroup[]) => {
        if (res?.length) {
          this.locations = res;
        }
        this.locationsLoaded = true;
      },
      (error) => {
        console.error(error);
        this.locationsLoaded = true;
      }
    );

    this.api.getOnlineStatusCompanyGroup().subscribe((res: any) => {
      this.onlineStatus = res;
    });
  }

  ngOnDestroy(): void {
    this.langSubscription?.unsubscribe();
  }
}
